var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index"},[_c('nav-bar'),(_vm.isMain)?_c('div',[_c('index-banner')],1):_c('div',[_c('ckList'),_c('GoodsList')],1),_c('Fastmail'),_c('bottom-footer'),_c('back-top')],1)}
var staticRenderFns = []

export { render, staticRenderFns }